/** Consumer domains that serve Soul Map from the shared enterprise deployment. */
const DEFAULT_SOULMAP_HOSTS = ['soulmap.us', 'www.soulmap.us'];

function getSoulMapHosts(): string[] {
  const raw = import.meta.env.VITE_SOULMAP_HOSTS?.trim();
  if (!raw) return DEFAULT_SOULMAP_HOSTS;

  return raw
    .split(',')
    .map((host) => host.trim().toLowerCase())
    .filter(Boolean);
}

export function isSoulMapHost(hostname?: string): boolean {
  if (typeof window === 'undefined' && !hostname) {
    return false;
  }

  const host = (hostname ?? window.location.hostname).trim().toLowerCase();
  return Boolean(host) && getSoulMapHosts().includes(host);
}

/**
 * Soul Map runs either as its own build (VITE_APP_MODE) or as a consumer
 * hostname on the shared deployment, so one project can serve both products.
 */
export function isSoulMapMode(): boolean {
  return import.meta.env.VITE_APP_MODE === 'soulmap' || isSoulMapHost();
}

export function getSoulMapPostLoginPath(tenantSlug: string): string {
  return `/${tenantSlug}/soulmap`;
}
